import { mix } from "@chorda/core";
export const ContentLayout = (elements) => {
    return mix({ css: 'content' }, { items: elements });
};
